/*
  {% render 'product-quantity-selector', product: product %}
*/

const initQuantityInputs = (container = document.querySelector('[data-product-main]')) => {
  const quantitySelectors = container.querySelectorAll('[data-quantity-selector]');

  if (!quantitySelectors.length) return;

  const changeInput = (qtyInput, value) => {
    if (qtyInput.checkValidity()) {
      const newValue = +qtyInput.value + value;
      qtyInput.value = String(newValue);
    }
  };

  const clampToMin = (qtyInput) => {
    const min = +qtyInput.min || 1;
    if (!qtyInput.checkValidity() || +qtyInput.value < min) {
      qtyInput.value = String(min);
    }
  };

  quantitySelectors.forEach(selector => {
    const qtyInput = selector.querySelector('[data-quantity-input]');

    qtyInput.addEventListener('change', () => clampToMin(qtyInput));
    selector.addEventListener('click', (evt) => {
      if (evt.target.closest('[data-quantity-dec]') && +qtyInput.value > 1) {
        changeInput(qtyInput, -1);
      } else if (evt.target.closest('[data-quantity-inc]')) {
        changeInput(qtyInput, +1);
      }
    });
  });
};

export default initQuantityInputs;
